// removed by extract-text-webpack-plugin
module.exports = {"BadgeDot":"BadgeDot-module__BadgeDot__1uU3g","BadgeDotSmall":"BadgeDot-module__BadgeDotSmall__2dXNB","Active":"BadgeDot-module__Active__1PebD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/BadgeDot/BadgeDot.module.css
// module id = 1782
// module chunks = 29